var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_vm._l((_vm.listArray),function(item,key){return [_c('check-item',{attrs:{"icon":item.icon,"title":item.title,"text":item.text}}),((key + 1)%2 === 0)?_c('div',{staticClass:"w-100"}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }